/* Bazan Home classic (port Home cũ GemPages → native, 10/10/2026).
   1) Carousel: [data-bzc-car] > [data-bzc-rail] (scroll-snap) + mũi tên + chấm.
   2) Video: [data-bzc-vid] bấm mới tải + play (preload none), play cái này thì pause cái khác.
   3) YouTube facade: [data-bzc-yt] bấm mới tạo iframe.
   4) Add to cart: [data-bzc-atc] → POST /cart/add.js (kèm selling_plan nếu có, giống Home cũ) → mở cart drawer theme. */
(function () {
  if (window.__bzcHome) return;
  window.__bzcHome = true;

  function initCarousel(car) {
    if (car.__bzc) return;
    car.__bzc = true;
    var rail = car.querySelector('[data-bzc-rail]');
    if (!rail) return;
    var prev = car.querySelector('[data-bzc-prev]');
    var next = car.querySelector('[data-bzc-next]');
    var dotsBox = car.querySelector('[data-bzc-dots]');
    var items = Array.prototype.filter.call(rail.children, function (el) { return el.offsetParent !== null || el.getClientRects().length; });

    function step() {
      if (items.length < 2) return rail.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }
    function gap() { return items.length < 2 ? 0 : step() - items[0].offsetWidth; }
    function perView() { return Math.max(1, Math.floor((rail.clientWidth + gap()) / step() + 0.1)); }
    function pages() { return Math.max(1, Math.ceil((items.length - perView()) / perView()) + 1); }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

    function buildDots() {
      if (!dotsBox) return;
      var n = maxScroll() > 4 ? pages() : 0;
      dotsBox.innerHTML = '';
      dotsBox.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bzc-dot';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
        dotsBox.appendChild(b);
      }
      sync();
    }
    function go(page) {
      var x = Math.min(page * perView() * step(), maxScroll());
      rail.scrollTo({ left: x, behavior: 'smooth' });
    }
    function sync() {
      var x = rail.scrollLeft, m = maxScroll();
      if (prev) prev.hidden = x <= 4;
      if (next) next.hidden = x >= m - 4 || m <= 4;
      if (dotsBox && dotsBox.children.length) {
        var p = x >= m - 4 ? dotsBox.children.length - 1 : Math.round(x / (perView() * step()));
        Array.prototype.forEach.call(dotsBox.children, function (d, i) { d.classList.toggle('is-on', i === p); });
      }
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -perView() * step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: perView() * step(), behavior: 'smooth' }); });
    var t;
    rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(buildDots, 150); });
    buildDots();
  }

  // Ảnh bìa video chỉ tải khi gần vào màn (12 video × ~40KB không tải lúc mở trang)
  var posterIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var v = e.target.querySelector('video');
      if (v && v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
      posterIO.unobserve(e.target);
    });
  }, { rootMargin: '400px 400px' }) : null;

  function initVideo(box) {
    if (box.__bzc) return;
    box.__bzc = true;
    var v = box.querySelector('video');
    if (v && v.dataset.poster) { if (posterIO) posterIO.observe(box); else v.poster = v.dataset.poster; }
    var btn = box.querySelector('[data-bzc-play]');
    if (!v || !btn) return;
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-bzc-vid] video').forEach(function (o) { if (o !== v) o.pause(); });
      if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src);
      v.controls = true;
      box.classList.add('is-playing');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    v.addEventListener('play', function () {
      document.querySelectorAll('[data-bzc-vid] video').forEach(function (o) { if (o !== v) o.pause(); });
    });
  }

  function initYT(box) {
    if (box.__bzc) return;
    box.__bzc = true;
    box.addEventListener('click', function () {
      var id = box.dataset.bzcYt;
      if (!id) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.title = box.getAttribute('aria-label') || 'Video';
      box.innerHTML = '';
      box.appendChild(f);
      box.classList.add('is-playing');
    }, { once: true });
  }

  function initATC(btn) {
    if (btn.__bzc) return;
    btn.__bzc = true;
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      var label = btn.textContent;
      var fd = new FormData();
      fd.append('id', btn.dataset.id);
      fd.append('quantity', '1');
      if (btn.dataset.plan) fd.append('selling_plan', btn.dataset.plan);
      fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) {
          btn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item }, bubbles: true }));
          setTimeout(function () { btn.textContent = label; }, 1500);
        })
        .catch(function (err) {
          btn.textContent = (err && err.description) ? 'Sold out' : 'Try again';
          setTimeout(function () { btn.textContent = label; }, 2000);
        })
        .then(function () { btn.classList.remove('is-busy'); });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-bzc-car]').forEach(initCarousel);
    root.querySelectorAll('[data-bzc-vid]').forEach(initVideo);
    root.querySelectorAll('[data-bzc-yt]').forEach(initYT);
    root.querySelectorAll('[data-bzc-atc]').forEach(initATC);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
